// extracted by mini-css-extract-plugin
module.exports = {"tab_wrapper":"tabs_tab_wrapper__3iK3z","tab_item":"tabs_tab_item__13f_J","active":"tabs_active__1sL8X"};